import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ContentTypeInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            setHeaders: {
                'X-Content-Type-Options': 'nosniff',
                'Strict-Transport-Security': 'max-age=31536000; includeSubdomains',
                'X-Frame-Options': 'SAMEORIGIN',
                'X-Xss-Protection': '1; mode=block',
                'Content-Security-Policy': "default-src 'self' data:"
                // 'Content-Security-Policy': "default-src https: data: 'unsafe-inline' 'unsafe-eval';'frame-ancestors' 'none' "
            }
        });

        return next.handle(request);
    }
}
